import { siteStats } from '@/mocks/site';

export default function StatsBar() {
  return (
    <section aria-label="站点数据" className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-300 bg-background-300 lg:grid-cols-4">
        {siteStats.map((item) => (
          <div key={item.label} className="bg-background-50 p-5 md:p-6">
            <p className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              {item.value}
            </p>
            <p className="mt-2 text-sm font-medium text-foreground-800">{item.label}</p>
            <p className="mt-1 text-xs font-label text-foreground-500">{item.hint}</p>
          </div>
        ))}
      </div>
    </section>
  );
}